"use client";

import { useEffect } from "react";
import { defaultLocale, isLocale } from "../i18n/config";

function getLocaleCookie(): string | undefined {
	const match = document.cookie
		.split("; ")
		.find((row) => row.startsWith("locale="));
	return match?.split("=")[1];
}

/**
 * Root page — reads the locale cookie (set by either CSR or SSR app)
 * and redirects to the matching locale path. Falls back to /en/.
 */
export default function RootPage() {
	useEffect(() => {
		const cookieLocale = getLocaleCookie();
		const locale =
			cookieLocale && isLocale(cookieLocale) ? cookieLocale : defaultLocale;
		window.location.replace(`/${locale}/${window.location.search}`);
	}, []);

	return null;
}
